export default function(measurement) {
  return measurement.description;
}
